/**
 * Codename generators, ported from the spy15 mockup.
 *
 * Operation names refer to missions, never to agents (playbook rule) —
 * these codes label the RUN and the difficulty envelopes.
 */

const ADJECTIVES = [
  "Red",
  "Amber",
  "Silver",
  "Night",
  "Iron",
  "Velvet",
  "Copper",
  "Ghost",
];

const NOUNS = [
  "Lantern",
  "Fox",
  "Compass",
  "Harbor",
  "Sparrow",
  "Ledger",
  "Marble",
  "Signal",
];

const DIFF_WORDS = [
  "Lantern",
  "Sparrow",
  "Compass",
  "Harbor",
  "Ledger",
  "Marble",
  "Signal",
  "Falcon",
  "Ember",
  "Cipher",
  "Meridian",
  "Vesper",
];

function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

/** Digit suffix 2–9 (mockup range — avoids 0/1 which read as O/I). */
function digit(): number {
  return 2 + Math.floor(Math.random() * 8);
}

/** Operation code for the run, e.g. "RedLantern7". */
export function genOpCode(): string {
  return `${pick(ADJECTIVES)}${pick(NOUNS)}${digit()}`;
}

/**
 * Three unique difficulty codenames, e.g. ["Lantern4","Sparrow7","Cipher9"]
 * — order is [beginner, challenging, improbable].
 */
export function genDiffCodes(): string[] {
  const words: string[] = [];
  while (words.length < 3) {
    const w = pick(DIFF_WORDS);
    if (!words.includes(w)) words.push(w);
  }
  return words.map((w) => `${w}${digit()}`);
}

/**
 * "RedLantern7" → "Red Lantern 7" for display on the envelope
 * (mockup's spaced rendering).
 */
export function spaceCode(code: string): string {
  return code
    .replace(/([A-Z0-9])/g, " $1")
    .replace(/(\d)/, " $1")
    .replace(/\s+/g, " ")
    .trim();
}
